import { fetch2, baseURL, get } from "./api";
import type { ContactState } from "@/types/contact";
/*
 @params
 domain=google.com,
 linked_url = "",
 force_search = true
*/
export function searchCompany(params: any = {}) {
  return get<{
    id: string;
    name: string;
    lid: string;
    url: string;
    description: string;
    numberOfEmployees: number;
    website: string;
    pictureUrl: string;
    type: string;
    companyResult: {
      name: string;
      url: string;
      description: string;
      address: {
        streetAddress: string;
        addressLocality: string;
        addressRegion: string;
        postalCode: string;
        addressCountry: string;
        addressCountryCode: string;
        rawAddress: string;
      };
      // numberOfEmployees: string;
      industry: string;
      website: string;
      specialties: Array<{
        value: string;
      }>;
      deleted: boolean;
      foundedYear: string;
      pictureUrl: string;
      estimatedRevenuRange: {
        estimatedMaxRevenue: {
          amount: number;
          unit: string;
          currency: string;
        };
        estimatedMinRevenue: {
          amount: number;
          unit: string;
          currency: string;
        };
      };
      annualRevenue: string;
      totalFunding: string;
      twitterUrl: string;
      facebookUrl: string;
      fundingEvents: Array<{
        id: string;
        date: string;
        type: string;
        investors: string;
        amount: string;
        currency: string;
        news_url: string;
      }>;
    };
    universalName: string;
  }>(baseURL + "/api/company/search/company", params, undefined, false);
}

type SearchEmployeeResult = {
  countStartTime: number; //调试使用，点数计算开始时间
  countEndTime: number; //调试使用，点数计算结束时间
  historyConsumedPoints: number; //调试使用，历史消耗点数
  isFreePackage: boolean; //是否是免费版本
  consumedPoints: number; //调试使用，本次消耗点数
  isFromCache: boolean;
  showLock?: boolean; //是否展示锁
  employees: {
    fullName: string;
    title: string;
    companyName: string;
    profilePictureUrl: string;
    summary: string;
    country: string;
    location: string;
    skills: string[];
    experience: {
      title: string;
      companyName: string;
      startDateYear: number;
      startDateMonth: number;
      endDateYear: number | null;
      endDateMonth: number | null;
      isCurrent: boolean;
      linkedinUrl: string;
      logoUrl?: string;
    }[];
    education: {
      fieldOfStudy: string;
      startDateYear: number;
      endDateYear: number | null;
      degree: string;
      schoolName: string;
      url?: string;
    }[];
    linkedinUrl: string;
    publicId: string;
    contactDetailVO: {
      //这个地方和  /api/contact/listContact 返回的状态字段结构相同
      emailState: ContactState; //一共四个状态
      emailList: [
        {
          name: string;
          email: string;
          source: string;
          usedTime: string;
          valid: boolean;
          used: boolean;
        },
      ];
      phoneState: ContactState;
      phoneList: [
        {
          name: string;
          phone: string;
          source: string;
          valid: boolean;
        },
      ];
    };
  }[];
};

/*
 @params
 domain=google.com, //和上一个接口相同
 universal_name = "", //上一个接口返回的universalName字段
 type = 1 //1代表搜索全员， 2代表搜索决策者
*/
export function searchEmployees(params: any = {}) {
  return get<SearchEmployeeResult>(
    baseURL + "/api/company/search/employees",
    params,
    undefined,
    false,
  )
  // .then((res) => {
  //   return {
  //     ...res,
  //     data: {
  //       ...res.data,
  //       employees:[],
  //       showLock: true,
  //       isFreePackage: false,
  //     },
  //   };
  // });
}

export function searchEmployeeByLinkedin(params: { linkedin_url: string }) {
  return get<SearchEmployeeResult>(
    baseURL + "/api/company/search/employees/linkedin",
    params,
    undefined,
    false,
  );
}

export type EnumCompanyType = {
  id?: string;
  createTime?: number;
  updateTime?: number;
  deleted?: boolean;
  type?: string;
  enumCode?: string;
  enumValue: string;
  desc?: string;
};

export function getEnumCompany(params: any = {}) {
  // return new Promise(function (resolve) {
  //   setTimeout(() => {
  //     resolve({
  //       data: [
  //         {
  //           id: "1",
  //           createTime: 1749499990000,
  //           updateTime: 1749748037000,
  //           deleted: false,
  //           type: "forbidden_domain",
  //           enumCode: "google",
  //           enumValue: "www.google.com",
  //           desc: "谷歌域名",
  //         },
  //       ],
  //       msg: "success",
  //       code: 200,
  //     });
  //   }, 10000);
  // });
  return get<EnumCompanyType[]>(
    baseURL + "/api/common/enums",
    params,
    {
      chromeCacheKey: "ExcludedDomainList",
    },
    false,
  );
}

// 侧边栏不自动弹出公司域名
export function nopopupCompanyList(params: any = {}) {
  return get(baseURL + "/api/company/nopopup/list", params, undefined, false);
}

export function searchCompanyEmployeesBylinkedin(params: any = {}) {
  return get(
    baseURL + "/api/company/search/employees/linkedin",
    params,
    undefined,
    false,
  )
  // .then((res) => {
  //   return {
  //     ...res,
  //     data: {
  //       ...res.data,
  //       employees:[],
  //       showLock: true,
  //       isFreePackage: false,
  //     },
  //   };
  // });
}
export function searchCompanyEmployeesByCondition(params: any = {}) {
  return fetch2(baseURL + "/api/company/search/employees/advanced", params, {
    loading: false,
  })
  // .then((res) => {
  //   return {
  //     ...res,
  //     data: {
  //       ...res.data,
  //       employees:[],
  //       showLock: true,
  //       isFreePackage: false,
  //     },
  //   };
  // });
}

export function exportSearchContacts(params: any = {}) {
  return fetch2(baseURL + "/api/company/export/contact", params, {
    loading: false,
  });
}
